import React from 'react';
import { Brand, Maybe, Price, ProductMedia } from '../../../../../types';
import { PriceDisplay, CurrentCampaign } from 'src/areas/product/types';
import { insertTableAds } from '../ads';
import { PriceListTableRow } from '../price-list-table';

const PriceListBody: React.FC<IPriceListBodyProps> = props => {
  const {
    sortedPrices,
    showMorePrices,
    numberOfVisiblePrices,
    adOffset,
    ...priceListTableRowProps
  } = props;

  return (
    <div>
      {sortedPrices &&
        sortedPrices.length > 0 &&
        insertTableAds(
          sortedPrices
            .slice(0, showMorePrices ? undefined : numberOfVisiblePrices)
            .map((item, index) => {
              const rowKey = `${item.id}-${index}`;
              return (
                <PriceListTableRow
                  key={rowKey}
                  item={item}
                  index={index}
                  {...priceListTableRowProps}
                />
              );
            }),
          adOffset ?? 0
        )}
    </div>
  );
};

interface IPriceListBodyProps {
  sortedPrices: Price[];
  showMorePrices: boolean;
  numberOfVisiblePrices: number;
  productId: number;
  productName?: string;
  campaign?: Maybe<CurrentCampaign>;
  media: ProductMedia & { first?: string | null };
  brand?: Maybe<Brand>;
  priceDisplay: PriceDisplay;
  adOffset?: number;
  splitList?: boolean;
}

export default PriceListBody;
